import PageLayout from 'components/PageLayout';
import {FC} from 'react';
import {useBackend} from 'state/backend';
import {Backend} from 'types/api';

import CodeForm from '../components/CodeForm';
import Notification, {MessageKind} from '../components/Notification';
export type DXHelperCodeFormBackend = Backend<{
    code?: string;
    completed?: boolean;
    message?: MessageKind;
}>;

const DXHelperCodeForm: FC = () => {
    const {data} = useBackend<DXHelperCodeFormBackend>();
    return (
        <PageLayout
            headerProps={{
                className: 'pb-3 sm:mt-[15vh] pl-6 sm:pl-2',
                showLanguage: window.innerWidth > 640,
            }}
        >
            <Notification className="mx-2 my-4 sm:mx-0" kind={data?.message} />
            <div className="items-center px-2 sm:px-0">
                <div className="rounded-lg border border-grey-300 bg-white p-2 pb-4 shadow-lg sm:p-6">
                    <CodeForm clientCode={data?.code} />
                </div>
            </div>
        </PageLayout>
    );
};

export default DXHelperCodeForm;
